import styled from "styled-components";

export const SearchBarDiv = styled.div`
  background-color: #202124;
  border-radius: 24px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  width: 300px;
  max-width: 100%;
`;


export const Input = styled.input`
  border: none;
  background-color: transparent;
  color: white;
  font-size: 18px;
  flex: 1;
`;

export const Button = styled.div`
  background-color: transparent;
color: white;  
border: none;
`;
